// 토큰 관리
export const getToken = () => {
  return localStorage.getItem('token');
};

export const setToken = (token) => {
  localStorage.setItem('token', token);
};

export const removeToken = () => {
  localStorage.removeItem('token');
};

// 토큰 유효성 검사
export const isTokenValid = () => {
  const token = getToken();
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Date.now() / 1000;
    
    return payload.exp > now;
  } catch (error) {
    return false;
  }
};

// 사용자 정보 추출
export const getUserFromToken = () => {
  const token = getToken();
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return {
      id: payload.user_id,
      email: payload.email,
      exp: payload.exp,
    };
  } catch (error) {
    return null;
  }
};

// 로그아웃
export const logout = () => {
  removeToken();
  window.location.href = '/login';
};

// 인증 상태 확인
export const isAuthenticated = () => {
  return getToken() !== null && isTokenValid();
};

export default {
  getToken,
  setToken,
  removeToken,
  isTokenValid,
  getUserFromToken,
  logout,
  isAuthenticated,
};